import { _ as _assert_this_initialized } from "@swc/helpers/_/_assert_this_initialized";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _get } from "@swc/helpers/_/_get";
import { _ as _get_prototype_of } from "@swc/helpers/_/_get_prototype_of";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import { Platform } from "react-native";
import { State } from "../../State";
import GestureHandler from "./GestureHandler";
var DEFAULT_MIN_DURATION_MS = 500;
var DEFAULT_MAX_DIST_DP = 10;
var SCALING_FACTOR = 10;
var LongPressGestureHandler = /*#__PURE__*/ function(GestureHandler) {
    "use strict";
    _inherits(LongPressGestureHandler, GestureHandler);
    var _super = _create_super(LongPressGestureHandler);
    function LongPressGestureHandler() {
        _class_call_check(this, LongPressGestureHandler);
        var _this;
        _this = _super.apply(this, arguments);
        _define_property(_assert_this_initialized(_this), "minDurationMs", DEFAULT_MIN_DURATION_MS);
        _define_property(_assert_this_initialized(_this), "defaultMaxDistSq", DEFAULT_MAX_DIST_DP * SCALING_FACTOR);
        _define_property(_assert_this_initialized(_this), "maxDistSq", _this.defaultMaxDistSq);
        _define_property(_assert_this_initialized(_this), "startX", 0);
        _define_property(_assert_this_initialized(_this), "startY", 0);
        _define_property(_assert_this_initialized(_this), "startTime", 0);
        _define_property(_assert_this_initialized(_this), "previousTime", 0);
        _define_property(_assert_this_initialized(_this), "activationTimeout", void 0);
        return _this;
    }
    _create_class(LongPressGestureHandler, [
        {
            key: "init",
            value: function init(ref, propsRef) {
                _get(_get_prototype_of(LongPressGestureHandler.prototype), "init", this).call(this, ref, propsRef);
                if (Platform.OS === "web") {
                    this.delegate.getView().oncontextmenu = function() {
                        return false;
                    };
                }
            }
        },
        {
            key: "transformNativeEvent",
            value: function transformNativeEvent() {
                return _object_spread_props(_object_spread({}, _get(_get_prototype_of(LongPressGestureHandler.prototype), "transformNativeEvent", this).call(this)), {
                    duration: Date.now() - this.startTime
                });
            }
        },
        {
            key: "updateGestureConfig",
            value: function updateGestureConfig(_param) {
                var _param_enabled = _param.enabled, enabled = _param_enabled === void 0 ? true : _param_enabled, props = _object_without_properties(_param, [
                    "enabled"
                ]);
                _get(_get_prototype_of(LongPressGestureHandler.prototype), "updateGestureConfig", this).call(this, _object_spread({
                    enabled: enabled
                }, props));
                if (this.config.minDurationMs !== undefined) {
                    this.minDurationMs = this.config.minDurationMs;
                }
                if (this.config.maxDist !== undefined) {
                    this.maxDistSq = this.config.maxDist * this.config.maxDist;
                }
            }
        },
        {
            key: "resetConfig",
            value: function resetConfig() {
                _get(_get_prototype_of(LongPressGestureHandler.prototype), "resetConfig", this).call(this);
                this.minDurationMs = DEFAULT_MIN_DURATION_MS;
                this.maxDistSq = this.defaultMaxDistSq;
            }
        },
        {
            key: "onStateChange",
            value: function onStateChange(_newState, _oldState) {
                clearTimeout(this.activationTimeout);
            }
        },
        {
            key: "onPointerDown",
            value: function onPointerDown(event) {
                this.tracker.addToTracker(event);
                _get(_get_prototype_of(LongPressGestureHandler.prototype), "onPointerDown", this).call(this, event);
                this.tryBegin(event);
                this.tryActivate();
                this.checkDistanceFail(event);
            }
        },
        {
            key: "onPointerMove",
            value: function onPointerMove(event) {
                _get(_get_prototype_of(LongPressGestureHandler.prototype), "onPointerMove", this).call(this, event);
                this.tracker.track(event);
                this.checkDistanceFail(event);
            }
        },
        {
            key: "onPointerUp",
            value: function onPointerUp(event) {
                _get(_get_prototype_of(LongPressGestureHandler.prototype), "onPointerUp", this).call(this, event);
                this.tracker.removeFromTracker(event.pointerId);
                if (this.currentState === State.ACTIVE) {
                    this.end();
                } else {
                    this.fail();
                }
            }
        },
        {
            key: "tryBegin",
            value: function tryBegin(event) {
                if (this.currentState !== State.UNDETERMINED) {
                    return;
                }
                this.previousTime = Date.now();
                this.startTime = this.previousTime;
                this.begin();
                this.startX = event.x;
                this.startY = event.y;
            }
        },
        {
            key: "tryActivate",
            value: function tryActivate() {
                var _this = this;
                if (this.minDurationMs > 0) {
                    this.activationTimeout = setTimeout(function() {
                        _this.activate();
                    }, this.minDurationMs);
                } else if (this.minDurationMs === 0) {
                    this.activate();
                }
            }
        },
        {
            key: "checkDistanceFail",
            value: function checkDistanceFail(event) {
                var dx = event.x - this.startX;
                var dy = event.y - this.startY;
                var distSq = dx * dx + dy * dy;
                if (distSq <= this.maxDistSq) {
                    return;
                }
                if (this.currentState === State.ACTIVE) {
                    this.cancel();
                } else {
                    this.fail();
                }
            }
        }
    ]);
    return LongPressGestureHandler;
}(GestureHandler);
export { LongPressGestureHandler as default };
